import {createTheme} from '@mui/material/styles';

import palette from './palette';

const theme = createTheme({palette});

export default theme;
